import { EntityAction } from '../../../../../entity-actions/interfaces/entity-actions';
import { Integration, IntegrationAction } from '../../../../../shared/interfaces/integration';
import { EntityActionsProps } from '../../../../../entity-actions/EntityActions';
import { DestinationAction } from '../../../../../shared/interfaces/destination';
import { SourceAction } from '../../../../../shared/interfaces/source';

interface PipelineDisplayDetail {
  key: string;
  title: string;
  displayConfigKey: string;
  getEntityActionsProps: (props: {
    integrationActions: EntityAction<IntegrationAction>[];
    destinationActions: EntityAction<DestinationAction>[];
    sourceActions: EntityAction<SourceAction>[];
    integration: Integration;
  }) => EntityActionsProps<string, unknown>;
}

export const PIPELINE_DISPLAY_CONFIGS: PipelineDisplayDetail[] = [
  {
    key: 'source',
    title: 'Source Configuration',
    displayConfigKey: 'sourceDisplayConfig',
    getEntityActionsProps: props => ({
      actions: props.sourceActions,
      entity: props.integration.source
    })
  },
  {
    key: 'destination',
    title: 'Destination Configuration',
    displayConfigKey: 'destinationDisplayConfig',
    getEntityActionsProps: props => ({
      actions: props.destinationActions,
      entity: props.integration.destination
    })
  },
  {
    key: 'pipeline',
    title: 'Pipeline Configuration',
    displayConfigKey: 'integrationDisplayConfig',
    getEntityActionsProps: props => ({
      actions: props.integrationActions,
      entity: props.integration
    })
  }
];
